import { initialState as buyer } from '../reducers/buyerReducer'
import { initialState as creator } from '../reducers/creatorReducer'
import { initialState as inflowHistory } from '../reducers/inflowHistoryReducer'
import { initialState as itemEntry } from '../reducers/itemEntryReducer'
import { initialState as landing } from '../reducers/landingReducer'
import { initialState as outflowHistory } from '../reducers/outflowHistoryReducer'
import { initialState as sellerHistory } from '../reducers/sellerHistoryReducer'
import { initialState as sms } from '../reducers/smsReducer'
import { initialState as tapPay } from '../reducers/tapPayReducer'
import { initialState as ui } from '../reducers/uiReducer'
import { initialState as user } from '../reducers/userReducer'
import { initialState as vendor } from '../reducers/vendorReducer'
import { initialState as withdraw } from '../reducers/withdrawReducer'

export default {
  buyer,
  creator,
  inflowHistory,
  itemEntry,
  landing,
  outflowHistory,
  sellerHistory,
  sms,
  tapPay,
  ui,
  user,
  vendor,
  withdraw,
}
